import { ApiQueries, DatePickerButton, ListItem, NoItems, Payment, prettyDate, StudentChip, useTitle } from "daymap-react";
import { PageContainer } from "../../components/layout";
import PageHeader from "../../containers/pageheader/pageheader"
import { alpha, Avatar, Box, Skeleton, Typography, useTheme } from "@mui/material";
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import PriorityHighIcon from '@mui/icons-material/PriorityHigh';
import DoneIcon from '@mui/icons-material/Done';
import { ReactNode, useState } from "react";

function Payments() {
    useTitle('Payments');
    const theme = useTheme();
    const [selected, setSelected] = useState<ApiQueries.payments.Payment>();
    const [from, setFrom] = useState(new Date(new Date().getFullYear(), 0, 1));
    const [to, setTo] = useState(new Date(new Date().getFullYear(), 11, 31));
    const {data, error, isPending} = new ApiQueries.payments.PaymentsList(from, to).ToQuery();

    return <>
        {selected && <Payment FormID={selected.FormID} RowID={selected.RowID} StudentID={selected.Student.ID} Comment={selected.Comment} onClose={() => setSelected(undefined)} />}
        <PageHeader title="Payments" />
        <PageContainer>
            <Box sx={{display:"flex", gap:1, padding:2}}>
                <Typography>
                    Showing payments from 
                    <DatePickerButton onChange={(value) => {if(value) {setFrom(value);}}} selectedDate={from}/>
                    to
                    <DatePickerButton onChange={(value) => {if(value) {setTo(value);}}} selectedDate={to}/>
                </Typography>
            </Box>
            {isPending &&             
                <Box sx={{ display: 'flex', flexFlow: 'column', gap: 1 }}>
                        <Skeleton variant="rounded" height={65} />
                        <Skeleton variant="rounded" height={65} />
                        <Skeleton variant="rounded" height={65} />
                        <Skeleton variant="rounded" height={65} />
                        <Skeleton variant="rounded" height={65} />
                </Box>
            }
            {data && 
                <Box sx={{ display: 'flex', flexFlow: 'column', gap: 1 }}>
                    {data.map(x => { 
                        const colour:string = x.PayStatus == 4 ? theme.palette.success.main : x.PayStatus == 3 ? theme.palette.error.main : theme.palette.info.main; 
                        const icon:ReactNode = x.PayStatus == 4 ? <DoneIcon/> : x.PayStatus == 3 ? <PriorityHighIcon/> : <AttachMoneyIcon/>; 
                        const iconAvatar = <Avatar variant="rounded" sx={{ height: 30, width: 30, bgcolor: alpha(colour, .15), color:colour }}>{icon}</Avatar>
                        const chips:ReactNode = <Box sx={{display:"flex", gap:1}}>
                            {x.Student && <StudentChip studentId={x.Student.ID} size="small"/>}
                        </Box>
                        let description = "";

                        if(x.PayStatus == 1)
                            description = x.ProviderMessage != "" ? x.ProviderMessage : `Payment Due`;
                        if(x.PayStatus == 3)
                            description = x.ProviderMessage;
                        if(x.PayStatus == 4)
                            description = `Paid $${(x.Amount / 100).toFixed(2)} ${x.Currency} on ${prettyDate(x.PaidLocalTime)}`;
                        return <ListItem
                            key={x.RowID}
                            title={x.Comment}
                            date={x.CreatedLocalTime}
                            avatar={iconAvatar}
                            chips={chips}
                            description={description}
                            onClick={() => setSelected(x)}
                        />
                    })}
                    {data.length == 0 && <NoItems>No payments available for the selected date range</NoItems>}
                    {error != null && <NoItems>{error.title}</NoItems>}
                </Box>
            }
        </PageContainer>   
    </>
}

export default Payments;